import { Outlet, Link, Route } from "react-router-dom";
import styles from "./Layout.module.css";
//import Azure from "../../assets/Azure.svg";
import Logo from "../../assets/genie-logo.svg";
import { CopyRegular, ShareRegular } from "@fluentui/react-icons";
import { useLocation } from "react-router-dom";
import { BackendURL } from "../../../env";
import {
  CommandBarButton,
  Dialog,
  Stack,
  TextField,
  ICommandBarStyles,
  IButtonStyles,
  DefaultButton,
} from "@fluentui/react";
import {
  useContext,
  useEffect,
  useState,
  Dispatch,
  SetStateAction,
} from "react";
import {
  HistoryButton,
  ShareButton,
  // ClearButton,
  LogOutButton,
  QuestionButton,
  ExportButton,
  ExpandCollapseButton,
  //   ToggleButton
} from "../../components/common/Button";
import {
  AppDropDown,
  ModelDropdown,
  SunDropdownAi,
} from "../../components/common/Dropdown";
import { AppStateContext } from "../../state/AppProvider";
import { CosmosDBStatus } from "../../api";
import { useNavigate } from "react-router-dom";
import UserProfile from "../../components/common/UserProfile";
import MybillDialog from "../../components/common/MybillsDialog/MybillDialog";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { useAppLogo } from "../../hooks/useAppLogo";

// interface LayoutProps {
//   onNewChat: () => void;
//   simpleHeader?: boolean;  // optional prop
// }

interface LayoutProps {
  onNewChat: () => void;
  simpleHeader?: boolean; // optional prop
  isToggled: boolean;
  setIsToggled: Dispatch<SetStateAction<boolean>>;
}

const shareButtonStyles: ICommandBarStyles & IButtonStyles = {
  root: {
    width: 86,
    height: 32,
    borderRadius: 4,
    background:
      "radial-gradient(109.81% 107.82% at 100.1% 90.19%, #0F6CBD 33.63%, #2D87C3 70.31%, #8DDDD8 100%)",
    //   position: 'absolute',
    //   right: 20,
    padding: "5px 12px",
    marginRight: "20px",
  },
  icon: {
    color: "#FFFFFF",
  },
  rootHovered: {
    background:
      "linear-gradient(135deg, #0F6CBD 0%, #2D87C3 51.04%, #8DDDD8 100%)",
  },
  label: {
    fontWeight: 600,
    fontSize: 14,
    lineHeight: "20px",
    color: "#FFFFFF",
  },
};

// const Layout = ({ onNewChat }: { onNewChat: () => void; simpleHeader?: boolean  }) => {

const Layout = ({
  onNewChat,
  simpleHeader,
  isToggled,
  setIsToggled,
}: LayoutProps) => {
  const [isSharePanelOpen, setIsSharePanelOpen] = useState<boolean>(false);
  const [isPopupOpen, setIsPopupOpen] = useState<boolean>(false);
  const [copyClicked, setCopyClicked] = useState<boolean>(false);
  const [copyText, setCopyText] = useState<string>("Copy URL");
  const [useAvatar, setUseAvatar] = useState(false);
  const appStateContext = useContext(AppStateContext);
  const navigate = useNavigate();
  const [Opentoggle, setonpentoggle] = useState(false);
  const [selectedModel, setSelectedModel] = useState<string>("");

  //const [isToggled, setIsToggled] = useState(false);

  //  const [isToggled, setIsToggled] = useState(() => {
  //   const saved = localStorage.getItem("dark-theme-enabled");ust
  //   return saved === "true" ? true : false;
  // });

  const handleToggle = () => {
    setIsToggled((prev) => !prev);
  };

  const handleShareClick = () => {
    setIsSharePanelOpen(true);
  };
  //   const handleLogout = async () => {
  //   localStorage.removeItem("AccessToken");
  //   localStorage.removeItem("user");
  //   localStorage.removeItem("profileImage");
  //   localStorage.removeItem("name");
  //   localStorage.removeItem("jobTitle");
  //   localStorage.removeItem("Expertise");
  //   localStorage.removeItem("Entraid");
  //   localStorage.removeItem("Email");

  //   await fetch(`${BackendURL}/api/logout`, {
  //     method: "POST",
  //     credentials: "include",
  //   });

  //   navigate("/signin");
  // };

  const handleSharePanelDismiss = () => {
    setIsSharePanelOpen(false);
    setCopyClicked(false);
    setCopyText("Copy URL");
  };

  const handleCopyClick = () => {
    navigator.clipboard.writeText(window.location.href);
    setCopyClicked(true);
  };

  const handleClearHistory = () => {
    setIsPopupOpen(true);
    //const clearChatHistory = 'clear';
    //appStateContext?.dispatch({ type: 'CLEAR_CHAT_HISTORY', payload: clearChatHistory });
  };
  const handleYesPopup = () => {
    const clearChatHistory = "clear";
    appStateContext?.dispatch({
      type: "CLEAR_CHAT_HISTORY",
      payload: clearChatHistory,
    });
    setIsPopupOpen(false);
  };
  const handleClearPopupDismiss = () => {
    setIsPopupOpen(false);
  };

  const handleHistoryClick = () => {
    appStateContext?.dispatch({ type: "TOGGLE_CHAT_HISTORY" });
    setonpentoggle((prevState) => !prevState);
  };

  const handleQuestionClick = () => {
    appStateContext?.dispatch({ type: "TOGGLE_PROMT_PANEL" });
  };

  const handelClick = () => {
    window.location.reload();
  };

  //   useEffect(() => {
  //   if (isToggled) {
  //     document.body.classList.add("dark-theme");
  //     localStorage.setItem("dark-theme-enabled", "true");
  //     console.log("dark theme")
  //   } else {
  //     document.body.classList.remove("dark-theme");
  //     localStorage.setItem("dark-theme-enabled", "false");
  //     console.log("light theme")
  //   }
  // }, [isToggled]);

  useEffect(() => {
    if (copyClicked) {
      setCopyText("Copied URL");
    }
  }, [copyClicked]);

  useEffect(() => {}, [appStateContext?.state.isCosmosDBAvailable.status]);

  function handleExportClick(): void {}

  //   const handleToggle = () => {
  //     setUseAvatar(!useAvatar);
  //   };

  const Userguide: React.FC<React.SVGProps<SVGSVGElement>> = () => (
    // <svg width="13" height="16" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    // <path d="M13 10.8571V1.71429C13 0.76928 12.2045 0 11.2273 0H2.95455C1.32585 0 0 1.28214 0 2.85714V13.7143C0 14.9743 1.05995 16 2.36364 16H12.4091C12.7356 16 13 15.7443 13 15.4286C13 15.1129 12.7356 14.8571 12.4091 14.8571H11.2273V12.5714C12.2045 12.5714 13 11.8021 13 10.8571ZM10.0455 14.8571H2.36364C1.71216 14.8571 1.18182 14.3443 1.18182 13.7143C1.18182 13.0843 1.71216 12.5714 2.36364 12.5714H10.0455V14.8571ZM2.36364 11.4286C1.93376 11.4286 1.52971 11.54 1.18182 11.735V2.85711C1.18182 1.9121 1.97732 1.14282 2.95455 1.14282H11.2273C11.553 1.14282 11.8182 1.39924 11.8182 1.71425V10.8571C11.8182 11.1721 11.553 11.4285 11.2273 11.4285L2.36364 11.4286ZM7.68182 9.14286C7.68182 9.45858 7.41739 9.71429 7.09091 9.71429H3.54545C3.21897 9.71429 2.95455 9.45858 2.95455 9.14286C2.95455 8.82714 3.21897 8.57143 3.54545 8.57143H7.09091C7.41739 8.57143 7.68182 8.82714 7.68182 9.14286ZM10.0455 3.42857C10.0455 3.74429 9.78103 4 9.45455 4H3.54545C3.21897 4 2.95455 3.74429 2.95455 3.42857C2.95455 3.11285 3.21897 2.85714 3.54545 2.85714H9.45455C9.78103 2.85714 10.0455 3.11285 10.0455 3.42857ZM10.0455 6.28571C10.0455 6.60144 9.78103 6.85714 9.45455 6.85714H3.54545C3.21897 6.85714 2.95455 6.60144 2.95455 6.28571C2.95455 5.96999 3.21897 5.71429 3.54545 5.71429H9.45455C9.78103 5.71429 10.0455 5.96999 10.0455 6.28571Z" fill="currentColor"/>
    // </svg>
    <svg
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.96207 9.84252C5.96207 10.3066 6.33909 10.6829 6.80418 10.6829C7.26926 10.6829 7.64629 10.3066 7.64629 9.84252V5.80884C7.64629 5.34473 7.26926 4.96851 6.80418 4.96851C6.33909 4.96851 5.96207 5.34473 5.96207 5.80884V9.84252Z"
        fill="currentColor"
      />
      <path
        d="M6.05453 3.76366C6.05453 4.22777 6.43156 4.604 6.89665 4.604C7.36173 4.604 7.73876 4.22777 7.73876 3.76366V3.57278C7.73876 3.10868 7.36173 2.73245 6.89665 2.73245C6.43156 2.73245 6.05453 3.10868 6.05453 3.57278V3.76366Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 2.77895C0 1.24418 1.24158 0 2.77314 0H10.8404C12.372 0 13.6135 1.24418 13.6135 2.77895V11.7895H13.6168V13.3052C13.4698 13.3052 13.3922 13.356 13.3371 13.4232C13.2695 13.5056 13.2021 13.6616 13.2021 13.8947C13.2021 14.2203 13.4655 14.4841 13.7903 14.4841V16H2.10086C0.940598 16 2.50732e-05 15.0574 0 13.8948V2.77895ZM12.101 2.77895V11.7895H2.10086C1.89667 11.7895 1.69928 11.8187 1.51262 11.8731V2.77895C1.51262 2.08133 2.07697 1.51579 2.77314 1.51579H10.8404C11.5366 1.51579 12.101 2.08133 12.101 2.77895ZM1.51262 13.8947C1.51262 13.5692 1.77599 13.3052 2.10086 13.3052H11.7576C11.7115 13.4981 11.6894 13.6969 11.6894 13.8947C11.6894 14.0993 11.7186 14.2972 11.7729 14.4841H2.10086C1.776 14.4841 1.51264 14.2203 1.51262 13.8947Z"
        fill="currentColor"
      />
    </svg>

    // <svg
    //   width="auto"
    //   height="16"
    //   viewBox="0 0 19 24"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <path
    //     d="M4.21054 0C2.0038 0 0.200195 1.81126 0.200195 4.01922V19.9807C0.210986 20.2123 0.310586 20.4309 0.478291 20.5909C0.645996 20.751 0.868913 20.8403 1.10075 20.8403C1.33259 20.8403 1.5555 20.751 1.72321 20.5909C1.89091 20.4309 1.99051 20.2123 2.0013 19.9807C2.0013 18.7456 2.9797 17.7627 4.21054 17.7627H16.0952C17.4065 17.7627 18.4908 16.6828 18.4908 15.3715V2.39113C18.4908 1.07987 17.4065 0 16.0952 0H4.21054ZM4.21054 1.80111H16.0952C16.4321 1.80111 16.6896 2.0542 16.6896 2.39113V15.3715C16.6896 15.7084 16.4321 15.9615 16.0952 15.9615H4.21054C3.34906 15.9615 2.65719 16.4165 2.0013 16.8843V4.01922C2.0013 2.78404 2.9797 1.80111 4.21054 1.80111Z"
    //     fill="currentColor"
    //   ></path>
    //   <path
    //     d="M1.10075 19.0802C0.861982 19.0804 0.633055 19.1754 0.46422 19.3442C0.295385 19.5131 0.200433 19.742 0.200195 19.9807C0.200195 22.1887 2.0038 24 4.21054 24H17.5902C17.829 23.9998 18.0579 23.9048 18.2267 23.736C18.3956 23.5671 18.4905 23.3382 18.4908 23.0994C18.4912 22.9808 18.4683 22.8633 18.4232 22.7536C18.3782 22.6439 18.312 22.5441 18.2283 22.46C18.1447 22.376 18.0452 22.3092 17.9357 22.2637C17.8262 22.2181 17.7088 22.1946 17.5902 22.1944H4.21054C2.9797 22.1944 2.0013 21.2159 2.0013 19.9807C2.00107 19.742 1.90611 19.5131 1.73728 19.3442C1.56844 19.1754 1.33952 19.0804 1.10075 19.0802Z"
    //     fill="currentColor"
    //   ></path>
    //   <path
    //     d="M9.68014 3.63327C7.98968 3.63328 6.63245 5.06177 6.63245 6.76081C6.63198 6.87979 6.65507 6.99767 6.70038 7.10768C6.7457 7.2177 6.81235 7.31765 6.89648 7.40178C6.98061 7.48591 7.08056 7.55256 7.19057 7.59787C7.30058 7.64318 7.41847 7.66627 7.53744 7.6658C7.65605 7.66568 7.77347 7.64216 7.88297 7.59659C7.99246 7.55101 8.09189 7.48427 8.17555 7.4002C8.25921 7.31613 8.32545 7.21638 8.37048 7.10666C8.41552 6.99694 8.43846 6.87941 8.438 6.76081C8.438 6.00086 9.00062 5.43881 9.68014 5.43881C10.3597 5.43881 10.9267 6.00086 10.9267 6.76081C10.9267 7.52076 10.3597 8.08722 9.68014 8.08724C9.44137 8.08748 9.21245 8.18243 9.04361 8.35127C8.87478 8.5201 8.77983 8.74903 8.77959 8.9878C8.77982 9.22657 8.87478 9.45549 9.04361 9.62432C9.21245 9.79316 9.44137 9.88813 9.68014 9.88837C11.3706 9.88834 12.7278 8.45985 12.7278 6.76081C12.7278 5.06177 11.3706 3.63328 9.68014 3.63327Z"
    //     fill="currentColor"
    //   ></path>
    //   <path
    //     d="M9.68009 8.08724C9.44133 8.08747 9.2124 8.18243 9.04357 8.35126C8.87473 8.5201 8.77978 8.74902 8.77954 8.98779V10.4429C8.77978 10.6817 8.87473 10.9106 9.04357 11.0794C9.2124 11.2482 9.44133 11.3432 9.68009 11.3434C9.91886 11.3432 10.1478 11.2482 10.3166 11.0794C10.4855 10.9106 10.5804 10.6817 10.5806 10.4429V8.98779C10.5804 8.74902 10.4855 8.5201 10.3166 8.35126C10.1478 8.18243 9.91886 8.08747 9.68009 8.08724Z"
    //    fill="currentColor"
    //   ></path>
    //   <path
    //     d="M10.7292 13.1377C10.7292 13.4155 10.6188 13.682 10.4223 13.8785C10.2258 14.075 9.95933 14.1854 9.68145 14.1854C9.40356 14.1854 9.13706 14.075 8.94056 13.8785C8.74407 13.682 8.63367 13.4155 8.63367 13.1377C8.63367 12.8598 8.74407 12.5933 8.94056 12.3968C9.13706 12.2003 9.40356 12.0899 9.68145 12.0899C9.95933 12.0899 10.2258 12.2003 10.4223 12.3968C10.6188 12.5933 10.7292 12.8598 10.7292 13.1377Z"
    //     fill="currentColor"
    //   ></path>
    // </svg>
  );

  const location = useLocation();
  const appLogo = useAppLogo();

  const isAdminPage = location.pathname.startsWith("/admin");

  //     useEffect(() => {
  //   if (isAdminPage) {
  //     document.body.classList.remove("dark-theme");
  //     return;
  //   }
  //   localStorage.setItem("dark-theme-enabled", isToggled.toString());

  //   if (isToggled) {
  //     document.body.classList.add("dark-theme");

  //   } else {
  //     document.body.classList.remove("dark-theme");

  //   }
  // }, [isToggled, isAdminPage]);

  const NewChatSvg: React.FC<React.SVGProps<SVGSVGElement>> = () => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.264 0.812573C12.3473 -0.270858 14.104 -0.270858 15.1874 0.812573C16.2709 1.896 16.2709 3.65259 15.1874 4.73602L9.91028 10.0132C9.23033 10.6931 8.34826 11.1341 7.39633 11.2701L5.45863 11.5469C5.18168 11.5865 4.90226 11.4934 4.70444 11.2956C4.50662 11.0977 4.41348 10.8183 4.45304 10.5414L4.72986 8.60366C4.86585 7.65173 5.30691 6.76958 5.98684 6.08968L11.264 0.812573ZM13.9304 2.06955C13.5412 1.68034 12.9101 1.68034 12.5209 2.06955L7.24381 7.34669C6.83584 7.75466 6.57124 8.28386 6.48965 8.85502L6.38041 9.61959L7.14489 9.51035C7.71604 9.42876 8.24534 9.16415 8.65331 8.75618L13.9304 3.47904C14.3196 3.08982 14.3196 2.45878 13.9304 2.06955ZM7.11058 0.889385C7.11093 1.38026 6.71336 1.77851 6.22247 1.7789C5.33495 1.77959 4.70871 1.78619 4.2188 1.83274C3.73914 1.87831 3.45297 1.95764 3.23356 2.06944C2.73183 2.32508 2.32392 2.733 2.06827 3.23472C1.949 3.4688 1.86708 3.77784 1.82313 4.31572C1.77834 4.86399 1.77764 5.56821 1.77764 6.57848V9.42271C1.77764 10.4329 1.77834 11.1372 1.82313 11.6854C1.86708 12.2233 1.949 12.5323 2.06827 12.7664C2.32392 13.2681 2.73183 13.6761 3.23356 13.9317C3.46763 14.051 3.77667 14.1328 4.31456 14.1768C4.86282 14.2216 5.56704 14.2224 6.57729 14.2224H9.42152C10.4318 14.2224 11.136 14.2216 11.6843 14.1768C12.2221 14.1328 12.5311 14.051 12.7653 13.9317C13.267 13.6761 13.6749 13.2681 13.9305 12.7664C14.0423 12.547 14.1217 12.2608 14.1672 11.7812C14.2138 11.2913 14.2204 10.665 14.2211 9.77753C14.2214 9.28663 14.6197 8.88897 15.1106 8.88942C15.6015 8.88977 15.9991 9.28806 15.9987 9.77886C15.998 10.6483 15.9928 11.3611 15.9369 11.9493C15.8801 12.5478 15.7664 13.079 15.5144 13.5734C15.0884 14.4096 14.4085 15.0895 13.5723 15.5156C13.0459 15.7838 12.4768 15.8957 11.829 15.9485C11.1999 16 10.4229 16 9.45956 16H6.53924C5.57593 16 4.79897 16 4.1698 15.9485C3.52199 15.8957 2.95297 15.7838 2.42653 15.5156C1.59032 15.0895 0.910448 14.4096 0.484382 13.5734C0.216144 13.047 0.104321 12.478 0.051392 11.8302C-1.74679e-05 11.201 -8.65454e-06 10.4241 2.33681e-07 9.46075V6.54044C-8.65454e-06 5.57711 -1.74679e-05 4.80014 0.051392 4.17096C0.104321 3.52314 0.216144 2.95413 0.484382 2.42769C0.910448 1.59147 1.59032 0.911614 2.42653 0.485539C2.92096 0.233612 3.45218 0.119922 4.05067 0.0630644C4.63893 0.00717521 5.35163 0.00193114 6.22106 0.00125563C6.71194 0.000873437 7.11022 0.398497 7.11058 0.889385Z"
        fill="currentColor"
      />
    </svg>
  );

  const handleButtonClick = () => {
    window.open(
      "https://genieprodexternalstorage.blob.core.windows.net/genieusermanual/LipiUserManual.pdf",
      "_blank",
    );
  };

  const sideBarEnable = appStateContext?.state.isChatHistoryOpen;

  return (
    <div className={styles.layout}>
      <header className={styles.header} role={"banner"}>
        <Stack
          horizontal
          verticalAlign="center"
          horizontalAlign="space-between"
          // className={styles.headerContainer}
        >
          {/* <Stack
              horizontal
              verticalAlign="center"
              className={styles.logoWrapper}
            >
              {appStateContext?.state.isCosmosDBAvailable?.status !==
                CosmosDBStatus.NotConfigured && (
                  <button
                    className={styles.sidebarToggleBtn}
                    onClick={handleHistoryClick}

                    //@ts-ignore
                    text={
                      appStateContext?.state?.isChatHistoryOpen
                        ? "Hide chat history"
                        : "Show chat history"
                    }
                  >
                    <i>
                      <svg stroke="currentColor" fill="none" stroke-width="0" viewBox="0 0 15 15" height="18" width="18" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 3C1.22386 3 1 3.22386 1 3.5C1 3.77614 1.22386 4 1.5 4H13.5C13.7761 4 14 3.77614 14 3.5C14 3.22386 13.7761 3 13.5 3H1.5ZM1 7.5C1 7.22386 1.22386 7 1.5 7H13.5C13.7761 7 14 7.22386 14 7.5C14 7.77614 13.7761 8 13.5 8H1.5C1.22386 8 1 7.77614 1 7.5ZM1 11.5C1 11.2239 1.22386 11 1.5 11H13.5C13.7761 11 14 11.2239 14 11.5C14 11.7761 13.7761 12 13.5 12H1.5C1.22386 12 1 11.7761 1 11.5Z" fill="currentColor"></path></svg>
                    </i>
                  </button>

                )} */}

          {/* <ReactTooltip
              className={styles.customTooltip}
                id="my-tooltip-sidebartoggle"
                place="bottom"
                content={`${Opentoggle?"Close Sidebar":"Open Sidebar"}`}
              /> */}
          {/* <div className={styles.logoIconWrapper}> */}
          {/* <span className={styles.imgLogo}>
                  <img
                    src={Logo}
                    className={styles.headerIcon}
                    aria-hidden="true"
                  />
                </span> */}

          {/* <Link to="/" className={styles.headerTitleContainer}> */}
          {/* <h1 className={styles.headerTitle}>Lipi</h1> */}
          {/* <img src={Logo} alt="Lipi" title="Lipi" />  */}
          {/* </Link> */}

          {/* <Stack className="SelectModal">
                  <DropdownAi />
                </Stack> */}
          {/* </div> */}
          {/* </Stack> */}

          <Stack
            horizontal
            tokens={{ childrenGap: 8 }}
            className={`${styles.NewChatWrapper} ${styles.action_btn_gap}`}
          >
            <div id="newChat" className={styles.NewChatWrapper}>
              <div
                // className={styles.sidebarHeaderLogo}
                // style={{ display: sideBarEnable ? 'block' : 'none' }}
                className={`${styles.sidebarHeaderLogo} ${
                  sideBarEnable || isAdminPage
                    ? styles.sidebarHLogo_active
                    : styles.sidebarHLogo_inactive
                } `}
              >
                <a href="javascript:void()">
                  {appLogo ? (
                    <img
                      src={appLogo}
                      alt="Lipi logo"
                      className={styles.customHeaderLogo}
                    />
                  ) : (
                    <svg
                      width="42"
                      height="24"
                      viewBox="0 0 58 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        id="logopath1"
                        d="M55.0589 4.27963C54.4429 4.27963 53.9133 4.0797 53.4702 3.67984C53.0379 3.27997 52.8218 2.77204 52.8218 2.15603C52.8218 1.54002 53.0379 1.02668 53.4702 0.616008C53.9133 0.205336 54.4429 0 55.0589 0C55.6965 0 56.2368 0.205336 56.6799 0.616008C57.123 1.02668 57.3446 1.54002 57.3446 2.15603C57.3446 2.73961 57.123 3.24215 56.6799 3.66363C56.2368 4.0743 55.6965 4.27963 55.0589 4.27963ZM56.9231 22.4843C56.9231 23.5228 56.0812 24.3647 55.0426 24.3647C54.0041 24.3647 53.1622 23.5228 53.1622 22.4843V9.64539C53.1622 8.60684 54.0041 7.76494 55.0426 7.76494C56.0812 7.76494 56.9231 8.60684 56.9231 9.64538V22.4843Z"
                      />
                      <path
                        id="logopath2"
                        d="M37.2763 21.3745C37.2683 21.3616 37.2541 21.3535 37.2389 21.3535C37.2148 21.3535 37.1952 21.3731 37.1952 21.3973V30.0221C37.1952 31.1145 36.3096 32 35.2173 32C34.1249 32 33.2393 31.1144 33.2393 30.0221V8.38873C33.2393 7.29634 34.1249 6.4108 35.2173 6.4108H35.6547C36.5055 6.4108 37.1952 7.1005 37.1952 7.95128V9.44848C37.1952 9.47239 37.2146 9.49177 37.2385 9.49177C37.2539 9.49177 37.2682 9.48341 37.276 9.47009C38.6284 7.1567 40.6021 6 43.1972 6C45.4138 6 47.1417 6.78165 48.3807 8.34496C49.6198 9.90827 50.2393 12.0079 50.2393 14.6438C50.2393 17.5651 49.5402 19.9043 48.142 21.6616C46.7438 23.4189 44.8341 24.2976 42.4128 24.2976C40.1928 24.2976 38.4806 23.3232 37.2763 21.3745ZM37.1611 14.4384V16.6122C37.1611 17.8903 37.5646 18.9743 38.3717 19.8644C39.1902 20.7544 40.2246 21.1995 41.475 21.1995C42.9414 21.1995 44.0895 20.6289 44.9194 19.4878C45.7605 18.3353 46.1811 16.7321 46.1811 14.6781C46.1811 12.955 45.789 11.6085 45.0046 10.6386C44.2316 9.65723 43.1801 9.16656 41.8502 9.16656C40.4406 9.16656 39.3038 9.66864 38.4399 10.6728C37.5874 11.677 37.1611 12.9322 37.1611 14.4384Z"
                        fill="#0D0D0D"
                      />
                      <path
                        id="logopath3"
                        d="M25.9636 23.0058C25.9623 22.9454 25.9369 22.8879 25.8925 22.8452C25.8481 22.8025 25.7882 22.778 25.7254 22.7768L18.6226 22.7775C18.617 22.7775 18.6123 22.7745 18.6067 22.7745C18.5738 22.7726 18.5413 22.767 18.5098 22.7577C18.4886 22.7538 18.4678 22.7484 18.4475 22.7413C18.418 22.7269 18.3904 22.7091 18.3653 22.6882C18.3486 22.6776 18.3327 22.6659 18.3177 22.6531C18.2957 22.6284 18.2766 22.6014 18.2609 22.5726C18.2503 22.5569 18.2407 22.5406 18.2324 22.5237C18.2296 22.5172 18.222 22.5138 18.2212 22.5054L16.095 16.4468C15.987 16.0827 15.9708 15.699 16.0478 15.3277C16.1248 14.9563 16.2927 14.608 16.5376 14.3114L21.3062 8.54369C21.4474 8.37108 21.6283 8.2322 21.8346 8.13792C22.0409 8.04364 22.2671 7.99651 22.4956 8.0002L22.4979 8.00249L22.5003 8.0002L22.5087 8.00211C22.7074 7.99972 22.9047 8.03565 23.0888 8.10775C23.2729 8.17986 23.4401 8.28669 23.5805 8.42194C23.6215 8.46137 23.6601 8.50304 23.696 8.54675L28.4638 14.313C28.7101 14.6124 28.8782 14.9642 28.9541 15.3389C29.03 15.7136 29.0115 16.1003 28.9001 16.4667L27.8977 19.3235C27.8803 19.3742 27.8527 19.4211 27.8163 19.4615C27.78 19.5019 27.7357 19.535 27.6861 19.5588C27.6364 19.5827 27.5823 19.5969 27.5269 19.6006C27.4715 19.6043 27.4159 19.5974 27.3632 19.5803C27.3106 19.5632 27.262 19.5363 27.2202 19.5011C27.1785 19.4659 27.1444 19.4231 27.1199 19.3752C27.0954 19.3273 27.081 19.2752 27.0776 19.2219C27.0741 19.1686 27.0817 19.1152 27.0998 19.0647L28.0962 16.2259C28.1674 15.9856 28.1781 15.7326 28.1273 15.4876C28.0766 15.2426 27.9659 15.0128 27.8044 14.8171L23.0414 9.04787C23.007 9.00751 22.9677 8.97125 22.9243 8.93986V14.1122C23.4502 14.2126 23.9185 14.4976 24.238 14.9116C24.5575 15.3256 24.7054 15.8391 24.6529 16.3521C24.6004 16.8651 24.3513 17.3411 23.954 17.6873C23.5567 18.0335 23.0397 18.2253 22.5035 18.2253C21.9673 18.2253 21.4503 18.0335 21.053 17.6873C20.6557 17.3411 20.4066 16.8651 20.3541 16.3521C20.3016 15.8391 20.4495 15.3256 20.769 14.9116C21.0885 14.4976 21.5568 14.2126 22.0827 14.1122L22.0823 8.93872C22.0391 8.97068 22.0004 9.00788 21.9672 9.0494L17.1978 14.8141C17.0377 15.0072 16.9273 15.2339 16.8758 15.4758C16.8243 15.7177 16.833 15.968 16.9013 16.206L18.9259 21.9692L25.727 21.9669C25.8688 21.9668 26.0092 21.9935 26.1402 22.0456C26.2712 22.0977 26.3903 22.1742 26.4905 22.2706C26.5908 22.367 26.6703 22.4814 26.7245 22.6074C26.7787 22.7333 26.8065 22.8683 26.8064 23.0046L26.8068 24.9599C26.8067 25.2352 26.6929 25.4992 26.4904 25.6939C26.2879 25.8885 26.0134 25.9979 25.727 25.998L16.8519 25.9999C16.796 26.0009 16.7405 25.9911 16.6885 25.9712C16.6366 25.9513 16.5893 25.9217 16.5494 25.884C16.5095 25.8464 16.4778 25.8015 16.4562 25.7519C16.4345 25.7023 16.4233 25.6491 16.4233 25.5954C16.4233 25.5416 16.4344 25.4884 16.456 25.4388C16.4776 25.3892 16.5092 25.3443 16.5491 25.3066C16.589 25.2689 16.6362 25.2392 16.6881 25.2193C16.7401 25.1993 16.7956 25.1895 16.8515 25.1904L25.7266 25.19C25.7579 25.1902 25.789 25.1844 25.818 25.1729C25.8469 25.1615 25.8733 25.1446 25.8954 25.1233C25.9176 25.102 25.9351 25.0767 25.947 25.0489C25.9589 25.021 25.965 24.9912 25.9648 24.961L25.9636 23.0058ZM21.575 17.0354C21.7586 17.2119 21.9926 17.3322 22.2473 17.3809C22.502 17.4296 22.7661 17.4046 23.006 17.309C23.246 17.2135 23.4511 17.0517 23.5953 16.8441C23.7396 16.6364 23.8167 16.3924 23.8167 16.1427C23.8167 15.893 23.7396 15.6489 23.5953 15.4413C23.4511 15.2336 23.246 15.0718 23.006 14.9763C22.7661 14.8807 22.502 14.8557 22.2473 14.9044C21.9926 14.9531 21.7586 15.0734 21.575 15.2499C21.329 15.4868 21.1908 15.8079 21.1908 16.1427C21.1908 16.4774 21.329 16.7985 21.575 17.0354Z"
                        fill="#DA2128"
                        stroke="#DA2128"
                        stroke-width="0.9"
                      />
                      <circle
                        id="logopathcircle"
                        cx="23.2471"
                        cy="2.24705"
                        r="2.24705"
                        fill="#DA2128"
                      />
                      <path
                        id="logopath5"
                        d="M14 25.2513C14 26.2171 13.2171 27 12.2513 27H2C0.895431 27 0 26.1046 0 25V2C0 0.895431 0.895431 0 2 0H2.19647C3.30104 0 4.19647 0.895431 4.19647 2V21.5026C4.19647 22.6071 5.0919 23.5026 6.19647 23.5026H12.2513C13.2171 23.5026 14 24.2855 14 25.2513Z"
                        fill="#0D0D0D"
                      />
                    </svg>
                  )}
                </a>
              </div>

              {
                // const sideBarEnable = appStateContext?.state.isChatHistoryOpen;
                //             className={`${styles.container} ${
                //   sideBarEnable ? styles.chatHistory_Active : ""
                // } `}
                /* <button  id="expand-collapse-icon" onClick={handleHistoryClick}
  data-tooltip-id="sidebar-tooltip"
  data-tooltip-content={sideBarEnable ? 'Expand' : 'Collapse '}>

      {sideBarEnable ? (
        // Expanded Sidebar Icon

        <i>
        <svg id="expandedIcon"
          width="24"
          height="24"
          viewBox="0 0 17 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
  <path d="M14.4254 2.42563C14.4254 1.98381 14.0671 1.62563 13.6254 1.62563H2.42539C1.98356 1.62563 1.62539 1.98381 1.62539 2.42563V13.6256C1.62539 14.0674 1.98357 14.4256 2.42539 14.4256H13.6254C14.0671 14.4256 14.4254 14.0674 14.4254 13.6256V2.42563ZM16.0254 13.6256C16.0254 14.951 14.9508 16.0256 13.6254 16.0256H2.42539C1.0999 16.0256 0.0253906 14.951 0.0253906 13.6256V2.42563C0.0253906 1.10015 1.09991 0.0256348 2.42539 0.0256348H13.6254C14.9508 0.0256348 16.0254 1.10014 16.0254 2.42563V13.6256Z" fill="#202939"/>
  <path d="M4.8252 15.2256V0.825635C4.8252 0.383808 5.18337 0.0256348 5.6252 0.0256348C6.06702 0.0256348 6.4252 0.383808 6.4252 0.825635V15.2256C6.4252 15.6675 6.06702 16.0256 5.6252 16.0256C5.18337 16.0256 4.8252 15.6675 4.8252 15.2256Z" fill="#202939"/>
  <path d="M9.06048 5.06011C9.35338 4.76722 9.81658 4.74915 10.1308 5.00543L10.1917 5.06011L12.5917 7.46011C12.7418 7.61014 12.8261 7.81357 12.8261 8.02574C12.8261 8.23791 12.7418 8.44134 12.5917 8.59136L10.1917 10.9914C9.87932 11.3038 9.3729 11.3038 9.06048 10.9914C8.74807 10.6789 8.74807 10.1725 9.06048 9.86011L10.8949 8.02574L9.06048 6.19136L9.0058 6.13043C8.74952 5.81621 8.76759 5.35301 9.06048 5.06011Z" fill="#202939"/>
  </svg>
  </i>


        

      ) : (
        <i>
      
        <svg id="collapsedIcon"
          width="24"
          height="24"
          viewBox="0 0 17 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
  <path d="M14.4254 2.45762C14.4254 2.0158 14.0671 1.65762 13.6254 1.65762H2.42539C1.98356 1.65762 1.62539 2.01579 1.62539 2.45762V13.6576C1.62539 14.0994 1.98357 14.4576 2.42539 14.4576H13.6254C14.0671 14.4576 14.4254 14.0994 14.4254 13.6576V2.45762ZM16.0254 13.6576C16.0254 14.983 14.9508 16.0576 13.6254 16.0576H2.42539C1.0999 16.0576 0.0253906 14.983 0.0253906 13.6576V2.45762C0.0253906 1.13213 1.09991 0.0576172 2.42539 0.0576172H13.6254C14.9508 0.0576172 16.0254 1.13213 16.0254 2.45762V13.6576Z" fill="#202939"/>
  <path d="M4.8252 15.2576V0.857617C4.8252 0.415791 5.18337 0.0576172 5.6252 0.0576172C6.06702 0.0576172 6.4252 0.415791 6.4252 0.857617V15.2576C6.4252 15.6994 6.06702 16.0576 5.6252 16.0576C5.18337 16.0576 4.8252 15.6994 4.8252 15.2576Z" fill="#202939"/>
  <path d="M12.5919 5.0921C12.299 4.79921 11.8358 4.78113 11.5215 5.03741L11.4606 5.0921L9.06061 7.4921C8.91058 7.64213 8.82623 7.84555 8.82623 8.05772C8.82623 8.2699 8.91058 8.47332 9.06061 8.62335L11.4606 11.0233C11.773 11.3358 12.2794 11.3358 12.5919 11.0233C12.9043 10.7109 12.9043 10.2045 12.5919 9.8921L10.7575 8.05772L12.5919 6.22335L12.6465 6.16241C12.9028 5.84819 12.8847 5.38499 12.5919 5.0921Z" fill="#202939"/>
  </svg>
  </i>


        
      )}

  </button> */
              }

              {/* <button className="topExpandCollapse" id="expand-collapse-icon" onClick={handleHistoryClick}
                  data-tooltip-id="sidebar-expandCollapse-tooltip"
                  data-tooltip-content={sideBarEnable ? 'Expand' : 'Collapse '}>

                  {sideBarEnable ? (
                    // Expanded Sidebar Icon

                    <i>
                      <svg id="expandedIcon"
                        width="16"
                        height="16"
                        viewBox="0 0 17 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M14.4254 2.42563C14.4254 1.98381 14.0671 1.62563 13.6254 1.62563H2.42539C1.98356 1.62563 1.62539 1.98381 1.62539 2.42563V13.6256C1.62539 14.0674 1.98357 14.4256 2.42539 14.4256H13.6254C14.0671 14.4256 14.4254 14.0674 14.4254 13.6256V2.42563ZM16.0254 13.6256C16.0254 14.951 14.9508 16.0256 13.6254 16.0256H2.42539C1.0999 16.0256 0.0253906 14.951 0.0253906 13.6256V2.42563C0.0253906 1.10015 1.09991 0.0256348 2.42539 0.0256348H13.6254C14.9508 0.0256348 16.0254 1.10014 16.0254 2.42563V13.6256Z" fill="#202939" />
                        <path d="M4.8252 15.2256V0.825635C4.8252 0.383808 5.18337 0.0256348 5.6252 0.0256348C6.06702 0.0256348 6.4252 0.383808 6.4252 0.825635V15.2256C6.4252 15.6675 6.06702 16.0256 5.6252 16.0256C5.18337 16.0256 4.8252 15.6675 4.8252 15.2256Z" fill="#202939" />
                        <path d="M9.06048 5.06011C9.35338 4.76722 9.81658 4.74915 10.1308 5.00543L10.1917 5.06011L12.5917 7.46011C12.7418 7.61014 12.8261 7.81357 12.8261 8.02574C12.8261 8.23791 12.7418 8.44134 12.5917 8.59136L10.1917 10.9914C9.87932 11.3038 9.3729 11.3038 9.06048 10.9914C8.74807 10.6789 8.74807 10.1725 9.06048 9.86011L10.8949 8.02574L9.06048 6.19136L9.0058 6.13043C8.74952 5.81621 8.76759 5.35301 9.06048 5.06011Z" fill="#202939" />
                      </svg>
                    </i>




                  ) : (
                    <i>

                      <svg id="collapsedIcon"
                        width="16"
                        height="16"
                        viewBox="0 0 17 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M14.4254 2.45762C14.4254 2.0158 14.0671 1.65762 13.6254 1.65762H2.42539C1.98356 1.65762 1.62539 2.01579 1.62539 2.45762V13.6576C1.62539 14.0994 1.98357 14.4576 2.42539 14.4576H13.6254C14.0671 14.4576 14.4254 14.0994 14.4254 13.6576V2.45762ZM16.0254 13.6576C16.0254 14.983 14.9508 16.0576 13.6254 16.0576H2.42539C1.0999 16.0576 0.0253906 14.983 0.0253906 13.6576V2.45762C0.0253906 1.13213 1.09991 0.0576172 2.42539 0.0576172H13.6254C14.9508 0.0576172 16.0254 1.13213 16.0254 2.45762V13.6576Z" fill="#202939" />
                        <path d="M4.8252 15.2576V0.857617C4.8252 0.415791 5.18337 0.0576172 5.6252 0.0576172C6.06702 0.0576172 6.4252 0.415791 6.4252 0.857617V15.2576C6.4252 15.6994 6.06702 16.0576 5.6252 16.0576C5.18337 16.0576 4.8252 15.6994 4.8252 15.2576Z" fill="#202939" />
                        <path d="M12.5919 5.0921C12.299 4.79921 11.8358 4.78113 11.5215 5.03741L11.4606 5.0921L9.06061 7.4921C8.91058 7.64213 8.82623 7.84555 8.82623 8.05772C8.82623 8.2699 8.91058 8.47332 9.06061 8.62335L11.4606 11.0233C11.773 11.3358 12.2794 11.3358 12.5919 11.0233C12.9043 10.7109 12.9043 10.2045 12.5919 9.8921L10.7575 8.05772L12.5919 6.22335L12.6465 6.16241C12.9028 5.84819 12.8847 5.38499 12.5919 5.0921Z" fill="#202939" />
                      </svg>
                    </i>



                  )}

                </button>

                <ReactTooltip
                  id="sidebar-expandCollapse-tooltip"
                  place="right"
                  className={styles.customTooltip}
                /> */}

              {/* <div style={{ display: sideBarEnable ? "block" : "none" }}> */}
              <div
                className={
                  sideBarEnable
                    ? "newChatButtonActive"
                    : "newChatButtonInActive"
                }
              >
                <button
                  className="newChat"
                  data-tooltip-id="newChat"
                  onClick={onNewChat}
                >
                  <i>
                    <NewChatSvg />
                  </i>{" "}
                  <span>New Chat</span>
                </button>

                <ReactTooltip
                  className={styles.customTooltip}
                  id="newChat"
                  place="right"
                  content="New Chat"
                />
              </div>

              {!isAdminPage && (
                <>
                  <Stack className="SelectModal" data-tooltip-id="lipiModels">
                    <ModelDropdown />
                  </Stack>
                  <Stack className="SelectModal" data-tooltip-id="lipiApps">
                    <AppDropDown />
                  </Stack>
                </>
              )}

              <ReactTooltip
                className={styles.customTooltip}
                id="lipiModels"
                place="right"
                content="Lipi Models"
              />

              <ReactTooltip
                className={styles.customTooltip}
                id="lipiApps"
                place="right"
                content="Lipi Apps"
              />
            </div>
          

            <div className={styles.modelUserProfile}>
              {!isAdminPage && (
                <button
                  className="newChat themebutton"
                  data-tooltip-id="themeTooltip"
                  data-tooltip-content={isToggled ? "Light" : "Dark"}
                  onClick={handleToggle}
                >
                  {isToggled ? (
                    <i>
                      <svg
                        stroke="currentColor"
                        fill="none"
                        strokeWidth="2"
                        viewBox="0 0 24 24"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        aria-hidden="true"
                        height="24"
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle cx="12" cy="12" r="5"></circle>
                        <line x1="12" y1="1" x2="12" y2="3"></line>
                        <line x1="12" y1="21" x2="12" y2="23"></line>
                        <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
                        <line
                          x1="18.36"
                          y1="18.36"
                          x2="19.78"
                          y2="19.78"
                        ></line>
                        <line x1="1" y1="12" x2="3" y2="12"></line>
                        <line x1="21" y1="12" x2="23" y2="12"></line>
                        <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
                        <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
                      </svg>
                    </i>
                  ) : (
                    <i>
                      <svg
                        stroke="currentColor"
                        fill="none"
                        strokeWidth="2"
                        viewBox="0 0 24 24"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        aria-hidden="true"
                        height="24"
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
                      </svg>
                    </i>
                  )}
                </button>
              )}
              <ReactTooltip
                id="themeTooltip"
                place="bottom"
                className="customTooltip"
              />
              {/* <Stack className="SelectModal">
                <DropdownAi />
              </Stack> */}

              {/* chngaes */}

              {/* <SunDropdownAi /> */}
              {/* <div>
                                  <label htmlFor="">Select Model :</label>
                                  <select onChange={changeHandler} className="{styles.selectDiv}">
                                  <option value="Bard">Bard</option>
                                  <option value="GPT4">GPT-4</option>
                                  <option value="GenieDocs">GenieDocs</option>
                                  </select>
                                  {isVisible ? (
                                  <select className="{styles.selectDiv">
                                      <option value="azureblob-index-finance">FINANCE</option>
                                      <option value="azureblob-index-hr">HR</option>
                                      <option value="azureblob-index-policy">POLICY</option>
                                      <option value="azureblob-index-profile">PROFILE</option>
                                  </select>
                                  ) : null}
                              </div> */}

              {/* <ExportButton onClick={handleExportClick} /> */}
              {/* <ToggleButton checked={useAvatar} onChange={handleToggle} /> */}

              {/* {appStateContext?.state.isCosmosDBAvailable?.status !==
                  CosmosDBStatus.NotConfigured && (
                  <HistoryButton
                    onClick={handleHistoryClick}
                    text={
                      appStateContext?.state?.isChatHistoryOpen
                        ? "Hide chat history"
                        : "Show chat history"
                    }
                  />
                )} */}
              {/* <ExpandCollapseButton onClick={handleQuestionClick} /> */}
              {/* <QuestionButton onClick={handleQuestionClick} /> */}

              {/* <ClearButton onClick={handleClearHistory} /> */}

              {/* <LogOutButton onClick={handleLogout} /> */}
              {/* <div style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",

              }} className="UserGuid_btn"> */}

              {/* <button
                onClick={handleButtonClick}
                title="User Guide"
                className="UserGuid_btn"
                data-tooltip-id="my-tooltip-2"
              >
                <i>
                  <Userguide />
                </i>
              </button>
              <ReactTooltip
                className={styles.customTooltip}
                id="my-tooltip-2"
                place="bottom"
                content="User Guide"
              /> */}
              {/* </div> */}

              {/* {!isAdminPage && ( */}
              <UserProfile />
              {/* // )} */}

              {/* <MybillDialog /> */}
              {/* <ShareButton onClick={handleShareClick} /> */}
            </div>
          </Stack>
        </Stack>
      </header>
      <Outlet />
      <Dialog
        onDismiss={handleClearPopupDismiss}
        hidden={!isPopupOpen}
        styles={{
          main: [
            {
              selectors: {
                ["@media (min-width: 480px)"]: {
                  maxWidth: "600px",
                  background: "#FFFFFF",
                  boxShadow:
                    "0px 14px 28.8px rgba(0, 0, 0, 0.24), 0px 0px 8px rgba(0, 0, 0, 0.2)",
                  borderRadius: "8px",
                  maxHeight: "270px",
                  minHeight: "100px",
                },
              },
            },
          ],
        }}
        dialogContentProps={{
          //title: "Share the web app",
          showCloseButton: false,
        }}
      >
        <Stack horizontal verticalAlign="center" style={{ gap: "8px" }}>
          <div className={styles.popupWrp}>
            <div className={styles.popupIco}>
              <svg
                _ngcontent-pbk-c15=""
                width="36"
                height="36"
                viewBox="0 0 36 36"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g _ngcontent-pbk-c15="" clip-path="url(#clip0_134_8)">
                  <path
                    _ngcontent-pbk-c15=""
                    d="M18.0003 8.5H17.9997C17.6455 8.5002 17.2953 8.5746 16.9715 8.71839C16.6478 8.86219 16.3578 9.0722 16.1202 9.33489C15.8826 9.59759 15.7026 9.90714 15.5919 10.2436C15.4812 10.5801 15.4423 10.936 15.4775 11.2885L16.2646 19.1759C16.3026 19.6092 16.5013 20.0127 16.8218 20.307C17.1432 20.6021 17.5636 20.7659 18 20.7659C18.4364 20.7659 18.8568 20.6021 19.1782 20.307C19.4987 20.0127 19.6974 19.6092 19.7354 19.1759L20.5225 11.2885C20.5225 11.2884 20.5225 11.2884 20.5225 11.2884C20.5577 10.936 20.5187 10.5801 20.4081 10.2436C20.2974 9.90714 20.1174 9.59759 19.8798 9.33489C19.6422 9.0722 19.3522 8.86219 19.0285 8.71839C18.7047 8.57459 18.3545 8.5002 18.0003 8.5ZM35.5 18C35.5 22.6413 33.6563 27.0925 30.3744 30.3744C27.0925 33.6563 22.6413 35.5 18 35.5C13.3587 35.5 8.90752 33.6563 5.62563 30.3744C2.34374 27.0925 0.5 22.6413 0.5 18C0.5 13.3587 2.34374 8.90752 5.62563 5.62563C8.90752 2.34374 13.3587 0.5 18 0.5C22.6413 0.5 27.0925 2.34374 30.3744 5.62563C33.6563 8.90752 35.5 13.3587 35.5 18ZM18.0045 22C17.2752 22 16.5757 22.2897 16.06 22.8055C15.5442 23.3212 15.2545 24.0207 15.2545 24.75C15.2545 25.4793 15.5442 26.1788 16.06 26.6945C16.5757 27.2103 17.2752 27.5 18.0045 27.5C18.7338 27.5 19.4333 27.2103 19.949 26.6945C20.4648 26.1788 20.7545 25.4793 20.7545 24.75C20.7545 24.0207 20.4648 23.3212 19.949 22.8055C19.4333 22.2897 18.7338 22 18.0045 22Z"
                    stroke="black"
                  ></path>
                </g>
                <defs _ngcontent-pbk-c15="">
                  <clipPath _ngcontent-pbk-c15="" id="clip0_134_8">
                    <rect
                      _ngcontent-pbk-c15=""
                      width="36"
                      height="36"
                      fill="white"
                    ></rect>
                  </clipPath>
                </defs>
              </svg>
            </div>
            <span className={styles.popupText}>
              Are you sure you want to clear the <br />
              conversation?
            </span>
            <button
              className={styles.yesBtn}
              onClick={handleYesPopup}
              type="button"
            >
              Yes
            </button>
            <button
              className={styles.noBtn}
              onClick={handleClearPopupDismiss}
              type="button"
            >
              No
            </button>
          </div>
        </Stack>
      </Dialog>
      <Dialog
        onDismiss={handleSharePanelDismiss}
        hidden={!isSharePanelOpen}
        styles={{
          main: [
            {
              selectors: {
                ["@media (min-width: 480px)"]: {
                  maxWidth: "600px",
                  background: "#FFFFFF",
                  boxShadow:
                    "0px 14px 28.8px rgba(0, 0, 0, 0.24), 0px 0px 8px rgba(0, 0, 0, 0.2)",
                  borderRadius: "8px",
                  maxHeight: "200px",
                  minHeight: "100px",
                },
              },
            },
          ],
        }}
        dialogContentProps={{
          title: "Share the web app",
          showCloseButton: true,
        }}
      >
        <Stack horizontal verticalAlign="center" style={{ gap: "8px" }}>
          <TextField
            className={styles.urlTextBox}
            defaultValue={window.location.href}
            readOnly
          />
          <div
            className={styles.copyButtonContainer}
            role="button"
            tabIndex={0}
            aria-label="Copy"
            onClick={handleCopyClick}
            onKeyDown={(e) =>
              e.key === "Enter" || e.key === " " ? handleCopyClick() : null
            }
          >
            <CopyRegular className={styles.copyButton} />
            <span className={styles.copyButtonText}>{copyText}</span>
          </div>
        </Stack>
      </Dialog>
    </div>
  );
};

export default Layout;
